<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Daftar BPKB Macet</h5>
            </template>
            <div class="search-wrapper align-items-center justify-content-between">
                <b-form-group
                    label="Keterlambatan H+"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper input-small-wrapper">
                        <b-input-group>
                            <b-form-input class="mr-2"
                                v-model="input.filterFromDays" name="filterFromDays"
                                type="number"
                            ></b-form-input>
                        </b-input-group>
                        <span class="d-flex align-items-center">s/d H+</span>
                        <b-input-group>
                            <b-form-input class="mr-2"
                                v-model="input.filterToDays" name="filterToDays"
                                type="number"
                            ></b-form-input>
                        </b-input-group>
                    </div>
                </b-form-group>
                <b-button variant="pgiBtn" class="mr-2 download-btn" :disabled="isLoading" @click="confirmLaporanWeb()">
                    Lihat di Web
                </b-button>
                <b-button variant="pgiBtn" class="download-btn" :disabled="isLoading" @click="confirmLaporanDownload()">
                    <i class="fa fa-download mr-2"></i>
                    Download Excel
                </b-button>
            </div>
        </b-card>
        <div v-if="showWebLaporan">
            <div class="text-center" v-if="isLoading">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div v-else>
                <div class="mb-4 d-flex align-items-center justify-content-between laporan-periode-wrapper">
                    <div class="laporan-periode">
                        <h4>Daftar BPKB Macet</h4>
                        <h6>{{$helper.changeDateFormat(todayDate)}} 
                            (
                            <span>H + {{ periodeStart }} </span>
                            <span v-if="periodeEnd != ''"> s/d H + {{ periodeEnd }}</span>
                            )
                        </h6>
                    </div>
                </div>
                <b-row>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-balance-scale"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Total BPKB Macet</p>
                                    <strong class="mb-0">
                                        {{$helper.addThousandSeparator(dataBpkbMacetAll.jumlah)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col lg="4" sm="6" cols="12">
                        <div class="custom-card-dashboard balance-card">
                            <div class="d-flex align-items-center">
                                <div class="card-icon">
                                    <i class="mb-2 fa fa-money"></i>
                                </div>
                                <div class="card-data ml-4">
                                    <p class="mb-0 text-muted">Nominal BPKB Macet</p>
                                    <strong class="mb-0">
                                        Rp. {{$helper.addThousandSeparator(dataBpkbMacetAll.pokokEfektif)}}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-card >
                    <template v-slot:header>
                        <h5>Daftar BPKB Macet Cabang</h5>
                    </template>
                    <div class="search-wrapper d-flex align-items-center justify-content-between">
                        <b-form-group
                            label="Filter"
                            label-for="filterInput"
                            class="form-inline form-group-wrapper mb-3"
                        >   
                            <div class="d-flex search-input-wrapper">
                                <multiselect
                                    class="ml-2 mr-2"
                                    name="filterCabang"
                                    v-model="input.filterCabang" 
                                    :options="cabangOption" 
                                    :internal-search="true"
                                    :allow-empty="true"
                                    deselect-label=""
                                    select-label=""
                                    label="name"
                                    track-by="name"
                                    placeholder="-- Pilih filter cabang --"
                                />
                                <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter()"> 
                                    <i class="fa fa-search"></i>
                                </b-button>
                                <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
                            </div>
                        </b-form-group>
                    </div>
                    <b-table bordered hover show-empty
                        :busy="isBusy"
                        :items="dataBpkbMacet" 
                        :fields="fields" 
                        :currentPage="currentPage" 
                        :perPage="perPage"
                        responsive class="mb-3">
                        <template v-slot:table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>  Loading data...</strong>
                            </div>
                        </template>
                        <template v-slot:empty>
                            Tidak ada data BPKB macet.
                        </template>
                        <template v-slot:cell(jumlah)="row">
                            <div class="text-right no-wrap">
                                {{ $helper.addThousandSeparator(row.item.jumlah) }}                 
                            </div>
                        </template>
                        <template v-slot:cell(pokokEfektif)="row">
                            <div class="text-right no-wrap" v-if="row.item.pokokEfektif == null">{{$helper.addThousandSeparator(row.item.pokokEfektif)}} </div>
                            <div class="text-right no-wrap" v-else-if="row.item.pokokEfektif < 0">- Rp{{$helper.addThousandSeparator(row.item.pokokEfektif).replace("-", "")}}</div>
                            <div class="text-right no-wrap" v-else>Rp. {{$helper.addThousandSeparator(row.item.pokokEfektif)}} </div>
                        </template>
                    </b-table>

                    <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                        <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                            <b-form-select v-model="input.show" id="showItems" @change="onLimitChange" :options="options">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled />
                                </template>
                            </b-form-select>
                            <span class="ml-2">{{ totalViewText }}</span>
                        </b-input-group>
                        <b-pagination class="mb-0"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="my-table"
                            @input="onPageChange"
                        ></b-pagination>
                    </div>
                </b-card>
            </div>
        </div>
        <b-modal id="modal-web-password" @shown="focusLaporanWebPassword" title="Confirm Web Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="webPasswordForm" @submit.prevent="openLaporanWeb">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordWeb"
                        v-model="input.passwordWeb"
                        name="passwordWeb"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelWebPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeWebPasswordBtn" :disabled="isSubmitting" type="submit" form="webPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-password" @shown="focusLaporanDownloadPassword" title="Confirm Download Laporan Pemasukan" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
            :hide-header-close="isSubmitting">
            <b-form id="downloadExcelPasswordForm" @submit.prevent="openLaporanDownload">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Password" class="mb-0">
                        <b-form-input ref="passwordDownload"
                        v-model="input.passwordDownload"
                        name="passwordDownload"
                        type="password"
                        required
                        ></b-form-input>
                    </b-form-group>
                </div>
            </b-form>
            <template v-slot:modal-footer="{ ok, cancel }">
                <b-button variant="secondary" name="cancelDownloadPasswordBtn" :disabled="isSubmitting" @click="cancel()">
                    Cancel
                </b-button>
                <b-button variant="pgiBtn" name="okeDownloadPasswordBtn" :disabled="isSubmitting" type="submit" form="downloadExcelPasswordForm">
                    <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                    {{isSubmitting ? 'Memproses...' : 'Submit'}}
                </b-button>
            </template>
        </b-modal>
        <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    name: 'daftar-bpkb-macet',
    data(){
        return{
            input:{
                filterFromDays: null,
                filterToDays: null,
                passwordDownload: "",
                passwordWeb: "",
                //
                
                show: 10,
                filterCabang: null,
            },

            //
            isLoading: false,
            filePathDownload: "",
            query: "",
            isSubmitting: false,
            showWebLaporan: false,
            periodeStart: '',
            periodeEnd: '',
            isBusy: true,
            todayDate: '',
            fields: [
                { key: "cabangName", label: "Cabang"},
                { key: "jumlah", label: "Jumlah Macet", sortable: true },
                { key: "pokokEfektif", label: "Nominal Macet", sortable: true },
            ],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            dataBpkbMacetAll : [],
            dataBpkbMacet: [],
            filePath: "",
            cabangOption: [],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
        }
    }, 
    methods: {
        focusLaporanWebPassword(){
            this.$refs.passwordWeb.focus()
        },
        focusLaporanDownloadPassword(){
            this.$refs.passwordDownload.focus()
        },
        confirmLaporanWeb(){
            if((this.input.filterToDays == null || this.input.filterFromDays == null) || (this.input.filterToDays == "" || this.input.filterFromDays == "")){
                this.$helper.toastErr(this, "Mohon isi hari mulai dan hari akhir filter!")
            }else if(((this.input.filterToDays != "" && this.input.filterFromDays != "") || (this.input.filterToDays != null && this.input.filterFromDays != null)) && (Number(this.input.filterToDays) < Number(this.input.filterFromDays))){
                this.$helper.toastErr(this, "Hari akhir lebih kecil daripada hari mulai!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanWeb()
                    this.input.passwordWeb = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-web-password')
                }
            }
        },

        openLaporanWeb(){
            this.showWebLaporan = true
            this.isLoading = true
            this.$bvModal.hide('modal-web-password')
            setTimeout(() => { this.axiosLaporanWeb() }, 500)
        },

        axiosLaporanWeb(){
            let getCabang = this.getOptionCabang()

            let getDataBpkbMacet = this.$axios.get(`laporan-eksekutif/bpkb-macet/?hDari=${this.input.filterFromDays}&hSampai=${this.input.filterToDays}&password=${this.input.passwordWeb}`).then(response => {
                this.dataBpkbMacetAll = response.data
                this.dataBpkbMacet = response.data.entries
                this.updateTotalItem()
        
            })

            Promise.all([getCabang, getDataBpkbMacet]).then(() => {
                this.input.filterCabang = null
                this.isLoading = false
                this.isBusy = false
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordWeb)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordWeb = ""
                this.periodeStart = this.input.filterFromDays
                this.periodeEnd = this.input.filterToDays

                var todayFormat = new Date();
                var dd = todayFormat.getDate();
                var mm = todayFormat.getMonth()+1; //January is 0!
                var yyyy = todayFormat.getFullYear();
                if(dd<10){
                        dd='0'+dd
                    } 
                    if(mm<10){
                        mm='0'+mm
                    } 

                todayFormat = yyyy+'-'+mm+'-'+dd;
                this.todayDate = todayFormat
            })
            .catch(error => {
                console.log(error)
                this.$helper.toastErr(this, error.response.data.reason)
                this.input.passwordWeb = ""
                this.showWebLaporan = false
                this.isLoading = false
            })
        },

        getOptionCabang(){
            if(this.cabangOption.length == 0){
                this.$axios.get("cabang/all-selection").then(response => {
                    response.data.forEach((element) => {
                        if(element.id != this.srcCabangId)
                            this.cabangOption.push(element)
                    })
                })
            }
        },

        confirmLaporanDownload(){
            this.showWebLaporan = false
            if((!this.$helper.isNotNullAndNotEmpty(this.input.filterToDays) || !this.$helper.isNotNullAndNotEmpty(this.input.filterFromDays))){
                this.$helper.toastErr(this, "Mohon isi hari mulai dan hari akhir filter!")
            }else if((this.$helper.isNotNullAndNotEmpty(this.input.filterFromDays) && this.$helper.isNotNullAndNotEmpty(this.input.filterToDays)) && (Number(this.input.filterToDays) < Number(this.input.filterFromDays))){
                this.$helper.toastErr(this, "Hari akhir lebih kecil daripada hari mulai!")
            }else{
                if(localStorage.getItem('isauthorized') == 'true'){
                    this.openLaporanDownload()
                    this.input.passwordDownload = localStorage.getItem('lapeksPassword')
                }else{
                    this.$bvModal.show('modal-download-password')
                }
            }
        },

        openLaporanDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            this.$bvModal.hide('modal-download-password')
            setTimeout(() => { this.axiosLaporanDownload() }, 500)
        },

        axiosLaporanDownload(){
            this.$axios.get(`laporan-eksekutif/bpkb-macet/dl/?hDari=${this.input.filterFromDays}&hSampai=${this.input.filterToDays}&password=${this.input.passwordDownload}`).then(response => {
                this.filePathDownload = response.data
                if(localStorage.getItem('isauthorized') == 'false'){
                    localStorage.setItem('lapeksPassword', this.input.passwordDownload)
                    localStorage.setItem('isauthorized', 'true')
                }
                this.input.passwordDownload = ""
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.input.passwordDownload = ""
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //----------------- Fungsi Ambil Data Daftar Gadai -----------------

        getDataBpkbMacet(){
            this.dataBpkbMacet = this.dataBpkbMacetAll.entries
            this.toggleBusy()
            this.updateTotalItem()
        },

        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.perPage = this.input.show
            this.onPageChange()
        },

        onPageChange(){
            let prevLimit = null
            let limit = null
            prevLimit = (this.currentPage-1) * this.input.show + 1
            limit = (this.currentPage-1) * this.input.show + this.input.show
            if(limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        onReset(){
            this.filter = ""
            this.toggleBusy()
            this.getDataBpkbMacet()
        },
        
        onFilter(){
            
            if(this.input.filterCabang == null){
                this.$helper.toastErr(this, "Silakan isi nama cabang terlebih dahulu!")
            }else{
                let filteredArray = []

                for (var x of this.dataBpkbMacetAll.entries) {
                    if(x.cabangId == this.input.filterCabang.id){
                        filteredArray.push(x)
                    }
                }
                
                this.dataBpkbMacet = filteredArray
                this.onFiltered(this.dataBpkbMacet)
            }
        },

        onFiltered(filteredItems) {
            this.rows = filteredItems.length
            this.currentPage = 1
            this.perPage = this.input.show
            let prevLimit = null
            let limit = null
            
            prevLimit = (this.currentPage-1) * this.rows + 1
            limit = (this.currentPage-1) * this.rows + this.rows
            if (limit > this.input.show) limit = this.input.show
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(){
            this.rows = this.dataBpkbMacet.length
            if (this.perPage > this.rows) this.perPage = this.rows
            this.totalViewText = "Menampilkan 1 - " + this.perPage + " dari " + this.rows + " entri"
        },


    },
}
</script>
